<ng-content select="label"></ng-content>

<div class="file-selector" [ngClass]="{ 'has-error': isShowMissingFileError }">
  <!-- When empty -->
  <div class="upload-button" *ngIf="!isDocumentSelected && !showFileLoader">
    <label>
      <span class="upload-text">{{ uploadButtonText }}</span>
      <input type="file" class="inputfile" #fileInput (change)="fileChange($event)" [accept]="getSupportedFileTypes()" />
    </label>
  </div>

  <!-- Imapge thumbnail (link to image) -->
  <a
    [style.background-image]="'url(' + getThumbnail(document).url + ')'"
    class="thumbnail-link"
    [ngClass]="{ 'thumbnail-icon': getThumbnail(document).useIconThumbnail }"
    *ngIf="isDocumentSelected && !showFileLoader"
    [href]="document.url"
    target="_blank"
    >{{ showFileTitle ? (document.title | truncate: 35) : '' }}
  </a>

  <button mat-mini-fab class="clear-fab mat-elevation-z2" type="button" (click)="clearFile()" *ngIf="isDocumentSelected || showFileLoader">
    <mat-icon aria-label="Delete photo" class="notranslate">close</mat-icon>
  </button>

  <mat-progress-bar *ngIf="showFileLoader" mode="determinate" [value]="uploadProgress" class="custom-progress-bar"></mat-progress-bar>
</div>

<div class="missing-file-error" *ngIf="isShowMissingFileError"><span>Please upload a file</span></div>

<p class="error-message" *ngIf="showFileUploadError === true">
  <label class="has-error"> <i class="fa fa-error"></i> An error has occurred</label>
</p>
<p class="error-message" *ngIf="fileTypeNotSupported === true">
  <label class="has-error"> <i class="fa fa-error"></i> Uploaded file type is not supported</label>
</p>
<p class="error-message" *ngIf="displayVirusDetectedError === true">
  <label class="has-error"> <i class="fa fa-error"></i> Virus detected</label>
</p>
